import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { Money } from '../../../core/model/money';
import { NonResidentialProperty } from '../../model/non-residential-property';

@Component({
    selector: 'app-non-residential-property-statistics',
    templateUrl: './non-residential-property-statistics.component.html',
    styleUrls: ['./non-residential-property-statistics.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NonResidentialPropertyStatisticsComponent implements OnInit {
  constructor() {}

  @Input() model: NonResidentialProperty;

  get averageContractAge(): number {
    return this.model ? this.model.averageContractAge : null;
  }
  get nextMonthRent(): Money {
    return this.model ? this.model.nextMonthRent : null;
  }

  ngOnInit() {}
}
